import { Trans } from 'react-i18next';

type TermsCheckboxProps = {
  i18nKey:
    | 'auth.components.common.terms.agreement'
    | 'auth.components.register_form.partner_terms_agreement';
  linkHref: string;
};

export function TermsCheckbox({ i18nKey, linkHref }: TermsCheckboxProps) {
  return (
    <div className="relative flex items-start">
      <input
        id="terms"
        name="terms"
        type="checkbox"
        required
        className="mt-0.5 size-4 cursor-pointer rounded border-spark-border-default text-spark-accent focus:ring-spark-accent-hover"
      />
      <label htmlFor="terms" className="ms-3 inline cursor-pointer text-sm text-spark-text-primary">
        <Trans
          ns="features"
          i18nKey={i18nKey}
          components={{
            terms: (
              // biome-ignore lint/a11y/useAnchorContent: Trans fills the anchor with the link text
              <a
                href={linkHref}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-spark-accent hover:text-spark-accent-hover"
              />
            ),
          }}
        />
      </label>
    </div>
  );
}
